// src/Pages/Admin/AddCategory.js
import React, { useState, useEffect } from "react";
import { db, storage } from "../../../firebase";
import {
  collection,
  addDoc,
  updateDoc,
  doc,
  onSnapshot,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import "./AddCategories.css";

const AddCategory = () => {
  const [mainCategory, setMainCategory] = useState("");
  const [mainCategoryImage, setMainCategoryImage] = useState(null);
  const [subCategory, setSubCategory] = useState("");
  const [selectedMain, setSelectedMain] = useState("");
  const [mainCategories, setMainCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  // Fetch categories in real time
  useEffect(() => {
    const unsub = onSnapshot(collection(db, "categories"), (snapshot) => {
      const cats = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setMainCategories(cats);
    });
    return () => unsub();
  }, []);

  // Add Main Category
  const handleAddMain = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      let imageUrl = "";
      let imagePath = "";

      if (mainCategoryImage) {
        const imageRef = ref(
          storage,
          `categories/${Date.now()}-${mainCategoryImage.name}`
        );

        console.log("Uploading:", mainCategoryImage.name);
        await uploadBytes(imageRef, mainCategoryImage);
        imageUrl = await getDownloadURL(imageRef);
        imagePath = imageRef.fullPath; // ✅ save path for deletion
        console.log("Download URL:", imageUrl);
      }

      await addDoc(collection(db, "categories"), {
        name: mainCategory,
        imageUrl: imageUrl || "",
        imagePath: imagePath || "",
        subCategories: [],
      });

      console.log("Category added with name:", mainCategory);

      setMainCategory("");
      setMainCategoryImage(null);
      document.querySelector("#mainCategoryFile").value = "";
    } catch (err) {
      console.error("Error adding main category:", err.message, err);
    } finally {
      setLoading(false);
    }
  };

  // Add Sub Category
  const handleAddSub = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const categoryDoc = mainCategories.find((cat) => cat.id === selectedMain);
      if (!categoryDoc) return;

      const updatedSubCats = [...categoryDoc.subCategories, subCategory];

      await updateDoc(doc(db, "categories", selectedMain), {
        subCategories: updatedSubCats,
      });

      setSubCategory("");
      setSelectedMain("");
    } catch (err) {
      console.error("Error adding sub category:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="add-category-page">
      <h2 className="page-title">Manage Categories</h2>

      {loading && (
        <div className="loading-overlay">
          <div className="golden-loader"></div>
          <p className="loading-text">Adding Category...</p>
        </div>
      )}

      <div className="category-forms">
        {/* Main Category Form */}
        <form className="form-card" onSubmit={handleAddMain}>
          <h3>Add Main Category</h3>
          <label>Main Category Name</label>
          <input
            type="text"
            value={mainCategory}
            onChange={(e) => setMainCategory(e.target.value)}
            placeholder="e.g. Necklace"
            required
          />

          <label>Upload Image (optional)</label>
          <input
            id="mainCategoryFile"
            type="file"
            accept="image/*"
            onChange={(e) => setMainCategoryImage(e.target.files[0])}
          />

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Adding..." : "Add Main Category"}
          </button>
        </form>

        {/* Sub Category Form */}
        <form className="form-card" onSubmit={handleAddSub}>
          <h3>Add Sub Category</h3>
          <label>Select Main Category</label>
          <select
            value={selectedMain}
            onChange={(e) => setSelectedMain(e.target.value)}
            required
          >
            <option value="">Choose Main Category</option>
            {mainCategories.map((cat) => (
              <option key={cat.id} value={cat.id}>
                {cat.name}
              </option>
            ))}
          </select>

          <label>Sub Category Name</label>
          <input
            type="text"
            value={subCategory}
            onChange={(e) => setSubCategory(e.target.value)}
            placeholder="e.g. Bridal, Temple"
            required
          />

          <button type="submit" className="btn-primary" disabled={loading}>
            {loading ? "Adding..." : "Add Sub Category"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddCategory;
